import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-activities-sms-consumption-list',
  templateUrl: './activities-sms-consumption-list.component.html',
  styleUrls: ['./activities-sms-consumption-list.component.scss']
})
export class ActivitiesSmsConsumptionListComponent implements OnInit {

  @Input() data;
  centerOrder;
  counterErrorOrder;
  counterOkOrder;
  smsOriginOrder;
  statsDateOrder;

  constructor() { }

  ngOnInit() {
    this.resetSortOrders();
  }


  public resetSortOrders() {
    this.centerOrder = 0;
    this.counterErrorOrder = 0;
    this.counterOkOrder = 0;
    this.smsOriginOrder = 0;
    this.statsDateOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'statsDate':
        this.statsDateOrder = (this.statsDateOrder === 0) ? 1 : (this.statsDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.StatsDate = a.StatsDate ? a.StatsDate : ' ';
            b.StatsDate = b.StatsDate ? b.StatsDate : ' ';
            return (a.StatsDate < b.StatsDate) ? -this.statsDateOrder : (a.StatsDate) ? this.statsDateOrder : 0;
          });
        break;
      case 'center':
        this.centerOrder = (this.centerOrder === 0) ? 1 : (this.centerOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.CenterName = a.CenterName ? a.CenterName : ' ';
            b.CenterName = b.CenterName ? b.CenterName : ' ';
            return (a.CenterName.toUpperCase() < b.CenterName.toUpperCase()) ? -this.centerOrder : (a.CenterName.toUpperCase() > b.CenterName.toUpperCase()) ? this.centerOrder : 0;
          });
        break;
      case 'smsOrigin':
        this.smsOriginOrder = (this.smsOriginOrder === 0) ? 1 : (this.smsOriginOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.SmsOrigin = a.SmsOrigin ? a.SmsOrigin : ' ';
            b.SmsOrigin = b.SmsOrigin ? b.SmsOrigin : ' ';
            return (a.SmsOrigin.toUpperCase() < b.SmsOrigin.toUpperCase()) ? -this.smsOriginOrder : (a.SmsOrigin.toUpperCase() > b.SmsOrigin.toUpperCase()) ? this.smsOriginOrder : 0;
          });
        break;
        case 'counterError':
          this.counterErrorOrder = (this.counterErrorOrder === 0) ? 1 : (this.counterErrorOrder === 1) ? -1 : 1;
          this.data = this.data.sort(
            (a, b) => {
              a.CounterError = a.CounterError || (a.CounterError === 0) ? a.CounterError : ' ';
              b.CounterError = b.CounterError || (b.CounterError === 0) ? b.CounterError : ' ';
              return (a.CounterError < b.CounterError) ? -this.counterErrorOrder : (a.CounterError > b.CounterError) ? this.counterErrorOrder : 0;
            });
          break;
        case 'counterOk':
          this.counterOkOrder = (this.counterOkOrder === 0) ? 1 : (this.counterOkOrder === 1) ? -1 : 1;
          this.data = this.data.sort(
            (a, b) => {
              a.CounterOk = a.CounterOk || (a.CounterOk === 0) ? a.CounterOk : ' ';
              b.CounterOk = b.CounterOk || (b.CounterOk === 0) ? b.CounterOk : ' ';
              return (a.CounterOk < b.CounterOk) ? -this.counterOkOrder : (a.CounterOk > b.CounterOk) ? this.counterOkOrder : 0;
            });
          break;
    }
  }

}
